import React, { useMemo, useState } from 'react';
import yellowLocationIcon from './yellow-location-icon.png';
import redLocationIcon from './red-location-icon.png';

import './NTVOutdoorHotspotStyle.scss';

const DEFAULT_HEIGHT = 140;

const NTVOutdoorHotspotStyle = ({
  scene,
  previewImgUrl,
  height = 1,
  onClick,
  media,
  previousMenuLink,
}) => {
  const subtitle = !scene?.areaType
    ? 'Top view'
    : scene?.areaType === 'internalArea'
    ? 'Nội khu'
    : 'Ngoại khu';

  const effectiveHeight = DEFAULT_HEIGHT + (previewImgUrl ? 30 : 0);

  const title = useMemo(() => {
    return media?.title || scene?.title || 'NEWSTAR TOWER';
  }, [media, scene]);

  const [isHovered, setIsHovered] = useState(true);

  const darkStyle = isHovered && scene.amenitiesScene;

  const pinIcon = darkStyle ? redLocationIcon : yellowLocationIcon;

  return (
    <div className="ntv-outdoor--hotspot-style">
      <div
        className="ntv-outdoor--hotspot-style--container"
        style={{ height: `${effectiveHeight * (media?.height || height)}px` }}
      >
        <div className="ntv-outdoor--hotspot-style--line"></div>
        <div
          className={`ntv-outdoor--hotspot-style--title ${
            darkStyle ? ' is-dark' : ''
          } ${scene ? 'cursor-pointer' : ''}`}
          onClick={scene && onClick}
          onMouseEnter={() => setIsHovered(false)}
          onMouseLeave={() => setIsHovered(true)}
        >
          <div className="ntv-outdoor--hotspot-style--title-icon">
            <div className="ntv-outdoor--hotspot-style--title-icon-circle">
              <img src={pinIcon} alt="location" />
            </div>
          </div>
          <div className="ntv-outdoor--hotspot-style--title-texts">
            {subtitle && (
              <div className="ntv-outdoor--hotspot-style--subtitle">
                {subtitle}
              </div>
            )}
            <div className="ntv-outdoor--hotspot-style--title-text">
              {title}
            </div>
          </div>
          {scene?.amenitiesScene && scene?.previewImgUrl && (
            <div
              className={`ntv-outdoor--hotspot-style--preview ${
                darkStyle ? 'is-hidden' : ''
              }`}
            >
              <img src={scene?.previewImgUrl} alt="preview" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NTVOutdoorHotspotStyle;
